import script from "./button-router.vue?vue&type=script&setup=true&lang=js"
export * from "./button-router.vue?vue&type=script&setup=true&lang=js"

import "./button-router.vue?vue&type=style&index=0&id=265d92a9&lang=scss"

const __exports__ = script;

export default __exports__